module.exports = __webpack_public_path__ + "img/main_wfh.a1b88549.jpg";